export const applySearchFilter = (
  entitiesByType,
  searchText,
  appliedFilters = {},
  assets = []
) => {
  const term = (searchText || "").toLowerCase();
  if (
    term === "" &&
    (!appliedFilters.labels ||
      Object.keys(appliedFilters.labels).length === 0 ||
      Object.keys(appliedFilters.labels).every(
        (label) => appliedFilters.labels[label] === false
      )) &&
    (!appliedFilters.assets ||
      Object.keys(appliedFilters.assets).length === 0 ||
      Object.keys(appliedFilters.assets).every(
        (asset) => appliedFilters.assets[asset] === false
      ))
  )
    return { ...entitiesByType };

  return Object.keys(entitiesByType).reduce((acc, entityType) => {
    const entities = entitiesByType[entityType] || [];
    acc[entityType] = entities.filter((entity) => {
      let filterMatches = false;
      if (term !== "") {
        filterMatches =
          entity?.display_name?.toLowerCase().includes(term) ||
          entity?.entity_type?.toLowerCase().includes(term) ||
          entity?.original_unique_id?.toLowerCase().includes(term) ||
          entity?.extra_info?.some((info) =>
            info?.toLowerCase().includes(term)
          ) ||
          entity?.sources?.some((source) =>
            source?.toLowerCase().includes(term)
          );
      }

      let labelsMatches = false;
      if (
        appliedFilters.labels &&
        Object.keys(appliedFilters.labels).length > 0 &&
        entity?.labels?.length > 0
      ) {
        labelsMatches = entity?.labels?.some(
          (label) => appliedFilters.labels[label]
        );
      }

      let assetsMatches = false;
      if (
        appliedFilters.assets &&
        Object.keys(appliedFilters.assets).length > 0
      ) {
        const checkedAssets = assets.filter(
          (asset) =>
            Object.keys(appliedFilters.assets).includes(asset.asset_id) &&
            appliedFilters.assets[asset.asset_id] === true
        );
        assetsMatches = checkedAssets.some((asset) =>
          asset.entity_ids.includes(entity.entity_id)
        );
      }
      return filterMatches || labelsMatches || assetsMatches;
    });

    return acc;
  }, {});
};
